const PaymentMethodTypes = {
  BANK_TRANSFER: 'bank_transfer',
  CARD: 'card',
  CASH: 'cash',
  E_WALLET: 'e-wallet',
  INSTALMENTS: 'instalments',
  INSTANT_PAYMENT: 'instant_payment',
  ON_REFERENCE: 'on_reference',
  OPEN_INVOICE: 'open invoice',
};

module.exports = PaymentMethodTypes;
